export const BG_UPDATE_CURRENT_ROW = 'concrete/BG_UPDATE_CURRENT_ROW'
export const UPDATE_CURRENT_ROW = 'concrete/UPDATE_CURRENT_ROW'



// WEBPACK FOOTER //
// ./src/components/background-canvas/action-types.js